
import React from 'react';
import { TextField, Grid, InputAdornment, IconButton } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import useCommonStyles from '../../CommonStyle/commonStyle';
import useStyles from './styles';

interface inputProp {
  name: string;
  handleChange: ((e: React.ChangeEvent<HTMLInputElement>) => void),
  label: string,
  placeholder?: string,
  value?: string,
  multiline?: boolean,
  rows?: number,
  maxRows?: number,
  half?: boolean,
  autoFocus?: boolean,
  type?: string,
  handleShowPassword?: (() => void)
}

const Input = ({ name, handleChange, label, half, autoFocus, multiline, rows, maxRows, type, handleShowPassword, placeholder, value }: inputProp) => {
  const classes = useStyles();
    const commonClasses = useCommonStyles();
  return (
    <Grid item xs={12} sm={half ? 6 : 12}>
      {/* <TextField
        defaultValue="react-bootstrap"
        label="Bootstrap"
        id="bootstrap-input"
        InputProps={{
          disableUnderline: true,
          // classes: {
          //   root: classes.bootstrapRoot,
          //   input: classes.bootstrapInput,
          // },
        }}
        InputLabelProps={{
          shrink: true,
          // className: classes.bootstrapFormLabel,
        }}
      /> */}
      <TextField
        name={name}
        onChange={handleChange}
        placeholder={placeholder}
        value={value}
        // variant="outlined"
        required
        fullWidth
        multiline={multiline}
        rows={rows}
        maxRows={maxRows}
        label={label}
        autoFocus={autoFocus}
        type={type}
        InputProps={name === 'password' || name === 'confirmPassword' ? {
          disableUnderline: true,
          classes: {
            root: classes.bootstrapRoot,
            input: classes.bootstrapInput,
          },
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleShowPassword}>
                {type === 'password' ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        } : {
          disableUnderline: true,
          classes: {
            root: classes.bootstrapRoot,
            input: classes.bootstrapInput,
          },
        }}
        //     InputProps={
        //       {
        //         disableUnderline: true,
        //         classes: {
        //           root: classes.bootstrapRoot,
        //           input: classes.bootstrapInput,
        //         },
        //         endAdornment: { name === 'confirmPassword' ? {(
        //           <InputAdornment position="end">
        //             <IconButton onClick={handleShowPassword}>
        //               {type === 'password' ? <Visibility /> : <VisibilityOff />}
        //             </IconButton>
        //           </InputAdornment>
        //         )}: { }}

        //   }
        // }
        InputLabelProps={{
          shrink: true,
          className: classes.bootstrapFormLabel,
        }}
      // InputProps={name === 'password' || name === 'confirmPassword' ? {
      //   endAdornment: (
      //     <InputAdornment position="end">
      //       <IconButton onClick={handleShowPassword}>
      //         {type === 'password' ? <Visibility /> : <VisibilityOff />}
      //       </IconButton>
      //     </InputAdornment>
      //   ),
      // } : {}}
      />
    </Grid>
  )
};

export default Input;